import { render, staticRenderFns } from "./show.page.vue?vue&type=template&id=52a3b116&scoped=true&"
import script from "./show.page.vue?vue&type=script&lang=ts&"
export * from "./show.page.vue?vue&type=script&lang=ts&"
import style0 from "./show.page.vue?vue&type=style&index=0&id=52a3b116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a3b116",
  null
  
)

export default component.exports